import { DialogService } from './dialog.service';
import { NavigateService } from './navigate.service';
import { NotificationService } from './notification.service';
import { RoutesService } from './routes.service';

export const SERVICES = [DialogService, NotificationService, RoutesService, NavigateService];
